import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const seedSeries = (days, peak) => {
  const out = [];
  const now = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(now);
    d.setDate(d.getDate() - i);
    const t = (days - i) / days;
    const noise = Math.sin(i * 0.7) * peak * 0.15 + (Math.random() - 0.5) * peak * 0.2;
    out.push({ date: fmt(d), count: Math.max(0, Math.round(peak * (0.4 + 0.6 * t) + noise)) });
  }
  return out;
};

const MOCK = (days = 30) => ({
  success: true,
  window_days: days,
  totals: {
    products: 1284, users: 3417, businesses: 612, enquiries: 248,
    categories: 32, sub_categories: 184, brands: 156, cities: 412, states: 28,
    conversations: 1872, rfqs: 96, saved_searches: 524, wishlists: 2310, orders: 71,
  },
  window: { products: 96, users: 184, businesses: 38, enquiries: 22, rfqs: 14, conversations: 312, saved_searches: 48, wishlists: 205 },
  growth: { products: 12.4, users: 8.1, businesses: -3.2, enquiries: 18.6 },
  series: {
    products: seedSeries(days, 12),
    users: seedSeries(days, 24),
    businesses: seedSeries(days, 5),
    enquiries: seedSeries(days, 4),
  },
  breakdowns: {
    productsByCategory: [
      { name: 'Electronics', count: 312 }, { name: 'Fashion', count: 248 },
      { name: 'Home & Kitchen', count: 186 }, { name: 'Sports', count: 142 },
      { name: 'Beauty', count: 118 }, { name: 'Automotive', count: 96 },
      { name: 'Books', count: 72 }, { name: 'Toys', count: 54 },
    ],
    productsByCity: [
      { name: 'Mumbai', count: 184 }, { name: 'Delhi', count: 156 },
      { name: 'Bangalore', count: 142 }, { name: 'Pune', count: 118 },
      { name: 'Hyderabad', count: 96 }, { name: 'Chennai', count: 88 },
      { name: 'Surat', count: 64 }, { name: 'Ahmedabad', count: 52 },
    ],
    productsByState: [
      { name: 'Maharashtra', count: 312 }, { name: 'Karnataka', count: 184 },
      { name: 'Gujarat', count: 148 }, { name: 'Delhi', count: 142 },
      { name: 'Tamil Nadu', count: 118 }, { name: 'Telangana', count: 96 },
    ],
  },
  recent: {
    users: [
      { first_name: 'Demo', last_name: 'User', email: 'demo@example.com', created_at: new Date().toISOString() },
    ],
    products: [
      { product_name: 'Demo Product', city: 'Mumbai', created_at: new Date().toISOString() },
    ],
    businesses: [
      { business_name: 'Demo Business', city: 'Pune', created_at: new Date().toISOString() },
    ],
    enquiries: [
      { first_name: 'Sample', last_name: 'Lead', phone: '9876543210', city: 'Delhi', created_at: new Date().toISOString() },
    ],
  },
  isMock: true,
});

export const fetchAdvancedAnalytics = createAsyncThunk(
  'analytics/fetchAdvanced',
  async (days = 30, { rejectWithValue }) => {
    try {
      const res = await axios.get(`/admin/dashboard/analytics?days=${days}`);
      if (res?.data?.success) return res.data;
      return MOCK(days);
    } catch (err) {
      // Fall back to mock so the dashboard stays usable
      return MOCK(days);
    }
  }
);

const initialState = {
  data: null,
  windowDays: 30,
  isLoading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    setWindowDays(state, action) {
      state.windowDays = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdvancedAnalytics.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAdvancedAnalytics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchAdvancedAnalytics.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { setWindowDays } = analyticsSlice.actions;
export default analyticsSlice.reducer;
